import React from 'react';
import PercentageBox from '../../shared/components/PercentageBox';

import { ReactComponent as ClickIcon } from '../../assets/icons/click.svg';
import { ReactComponent as BotIcon } from '../../assets/icons/bot.svg';
import TotalWave from '../../assets/images/total-wave.png';
import BotWave from '../../assets/images/bot-wave.png';

const OverviewTrafficStatCard = ({title, numClicks, clickPercentage, percentage, icon}) => {
  let iconElement = null;
  switch (icon) {
  case 'click':
    iconElement = <ClickIcon className="icon lg icon-click" />;
    break;
  case 'bot':
    iconElement = <BotIcon className="icon lg icon-bot" />;
    break;
  default:
    break;
  }

  return (
    <div className="traffic-card">
      <div className="traffic-card-body">
        <div className="traffic-card-content">
          <p className='margin-none'>
            {title}
          </p>
          <div className="traffic-card-stat-row">
            <div className="traffic-card-icon-wrap">
              {iconElement}
            </div>
            <div className="traffic-card__stats">
              <span className="traffic-card__value">
                {numClicks.toLocaleString()}
              </span>
              {clickPercentage !== undefined && (
                <span className="traffic-card__share">
                  {clickPercentage.toFixed(2)}%
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="traffic-card-divider" />

        <div className="traffic-card-side">
          <PercentageBox percentage={percentage}
                         red={percentage !== null && icon !== 'bot' && percentage < 0}
                         bot={icon === 'bot'} />

          <small className='info'>
            vs previous period
          </small>
        </div>
      </div>

      {icon === 'bot'   && <img className="traffic-card-wave"
                                src={BotWave}
                                alt="Bot traffic wave" />}
      {icon === 'click' && <img className="traffic-card-wave"
                                src={TotalWave}
                                alt="Total traffic wave" />}
    </div>
  );
}

export default OverviewTrafficStatCard;
